import { styled } from '@ghq-abi/design-system';

export const StyledHeader = styled('header', {
  height: '$appHeaderHeight',
  width: '$full',
  backgroundColor: '$white',
  borderBottom: 'none',
  px: '$4',
  zIndex: '$docked',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '$md',

  position: 'fixed',
  top: 0,

  '@lg': {
    px: '$6',
  },

  '@media (min-width: 680px)': {
    left: '$appMenuClosedWidth',
    width: 'calc($full - $appMenuClosedWidth)',
  },

  variants: {
    isMenuOpen: {
      true: {
        '@lg': {
          left: '$appMenuOpenWidth',
          width:
            'calc($full - $appMenuOpenWidth - var(--removed-body-scroll-bar-size, 0px))',
        },
      },
      false: {
        '@lg': {
          left: '$appMenuClosedWidth',
          width:
            'calc($full - $appMenuClosedWidth - var(--removed-body-scroll-bar-size, 0px))',
        },
      },
    },
  },
});
